import Modal from "Common/Components/Modal";
import DeleteModal from "Common/DeleteModal";
import { getImageUrl, ProductColors } from "constants/constants";
import { set } from "date-fns";
import { addProductVariant, deleteProductVariant, getProductVariantSku, updateProductVariant } from "helpers/backend_helper";
import { Common } from "helpers/common";
import { Pencil, Trash2, Printer, Eye, ScanBarcode, Copy } from "lucide-react";
import AddProductVariant from "pages/Ecommerce/Products/AddProductVariant";
import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ProductVariantType } from "types/ProductVariantType";
import MultiColorBox from "./MultiColorBox";
import { printBarcodes } from "utils/ScannerUtil";
import BarcodeDisplay from "./BarcodeDisplay";
import { NO_DISCOUNT } from "constants/settings";


// ProductPrice props:
interface ProductPriceProps {
    productName: string;
    productId: number;
    ProductVariants: any[];
    ProductSizes: any[];
    brandDiscount: number;
    ProductImages: any[];
    ProductColors: any[];
    ProductSKU: string;
    CombinedColorItems?: any[];
}

const ProductVariantComponent: React.FC<ProductPriceProps> = ({ productName, productId, ProductSizes, ProductVariants, brandDiscount, ProductImages, ProductColors, ProductSKU, CombinedColorItems
}: ProductPriceProps) => {

    console.log('ProductColors', ProductColors);
    const commonHelper = new Common();

    const [productVariantList, setProductVariantList] = useState<any[]>([]);

    // Delete Modal
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const deleteToggle = () => setDeleteModal(!deleteModal);
    const [deleteItem, setDeleteItem] = useState<any>({});;
    const [showModal, setShowModal] = useState<boolean>(false);
    const [productVariant, setProductVariant] = useState<any>();
    const [showBarcodePreview, setShowBarcodePreview] = useState<boolean>(false);
    const [selectedVariant, setSelectedVariant] = useState<any>(null);

    useEffect(() => {
        if (ProductVariants && ProductVariants.length > 0) { setProductVariantList(ProductVariants); }
    }, [ProductVariants]);


    console.log('productVariantList-2', productVariantList);

    const handleDeleteProductVariant = async () => {
        console.log('deleteProductVariant', deleteItem);

        try {
            if (deleteItem?.id) {
                const response = await deleteProductVariant(deleteItem);
                console.log('deleteProductVariant', response);
                onProductVariantDelete(true);
                // remove from productVariantList
                setProductVariantList(productVariantList => productVariantList.filter((item: any, idx) => item.id !== deleteItem.id));
                setDeleteModal(false);
                setDeleteItem({});

            }
        } catch (error) {
            onProductVariantDelete(false);
        }

    }


    const onProductVariantDelete = (status: boolean) => {
        if (status) {
            commonHelper.showSuccessMessage('Product variant has been successfully deleted.');

        } else {
            commonHelper.showErrorMessage('Something went wrong. Please try again later.');
        }
    }


    const handleAddProductVariant = async () => {

        setShowModal(true);

        const response = await getProductVariantSku();
        const sku = response.data[0];

        const newProductVariant = {
            productsizesProductvariants: { name: '', id: '' },
            colors: [],
            unitPrice: 0,
            buyingPrice: 0,
            setPrice: 0,
            netPrice: 0,
            discountPercent: 0,
            discountValue: 0,
            mrp: 0,
            colorCode: '',
            colorName: '',
            packOf: 1,
            inventory: 0,
            sizeId: '',
            id: '',
            isEdit: true,
            color: [],
            margin: 0,
            imageUrl: '',
            imageName: '',
            sku: sku,
            externalSku: '',
            productId: productId
        } as ProductVariantType

        setProductVariant(newProductVariant);
    }

    // TODO: delete this code
    const onProductVariantSave = async (item: any) => {

        try {

            if (productVariant.id == '') {
                setProductVariantList([item, ...productVariantList]);
            }
            else {

                const updatedProductVariants = productVariantList.map((productVariant: any) => {
                    return (productVariant.id == item.id) ? item : productVariant;
                });

                setProductVariantList(updatedProductVariants);
            }
            hideVariantPopup();
            console.log('on product variant save', item);

        } catch (error) {
            commonHelper.showErrorMessage('Some error occured. Please try again.');
        }
    }


    const editProductVariant = useCallback((editItem: any, index: number) => {
        // update the productVariantList
        const prodVarList = productVariantList.map((item: any, idx: number) => {
            //    if (item.id == editItem.id) {
            if (index == idx) {
                return { ...item, isEdit: true };
            }
            return { ...item, isEdit: false };
        });

        setProductVariantList(prodVarList);
        // onProductVariantEdit(editItem);


        setProductVariant(editItem);
        setShowModal(true);
        console.log('editProductVariant', editItem);
    }, [productVariantList]);

    // Delete Data
    const onClickDelete = useCallback((cell: any) => {
        setDeleteModal(true);
        if (cell.id) {
            setDeleteItem(cell);
        }
    }, []);


    const hideVariantPopup = useCallback(() => {
        setShowModal(false);
        setProductVariant(null);
    }, []);

    const handlePrintBarcodes = useCallback(() => {
        if (productVariantList && productVariantList.length > 0) {
            printBarcodes(productVariantList, productName);
        } else {
            commonHelper.showErrorMessage('No product variants to print barcodes for.');
        }
    }, [productVariantList, productName]);

    const handleShowBarcodePreview = useCallback((variant: any) => {
        setSelectedVariant(variant);
        setShowBarcodePreview(true);
    }, []);

    const handleCopyVariant = useCallback(async (variant: any) => {

        setShowModal(true);

        const response = await getProductVariantSku();
        const sku = response.data[0];

        const newProductVariant = {
            ...variant,
            id: '',
            sku: sku,
            sizeId: '',
            productsizesProductvariants: { name: '', id: '' },
            isEdit: false
        };
        setProductVariant(newProductVariant);
    }, []);



    return (

        <div>
            <div className="card  bg-custom-50 dark:bg-custom-500/200">
                <div className={`card-body ${productId ? '' : 'bg-gray-300 cursor-not-allowed'}`} style={{ pointerEvents: productId ? 'auto' : 'none' }}>
                    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                        <div className="xl:col-span-12 flex justify-end gap-2">
                            <button type="button" onClick={handlePrintBarcodes} className="text-white transition-all duration-200 ease-linear btn bg-green-500 border-green-500 hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/20">
                                <Printer className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                                {"Print Barcodes"}
                            </button>
                            <button type="button" onClick={handleAddProductVariant} className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                {"+ Add Variant"}
                            </button>
                        </div>
                        <div className="xl:col-span-12">
                            <div >
                                <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDeleteProductVariant} />

                                <div className="xl:col-span-12 border-b border-dashed">
                                    <table className="w-full bg-custom-50 dark:bg-custom-500/10">
                                        <thead className="ltr:text-left rtl:text-right bg-slate-200 dark:bg-slate-500/10">
                                            <tr>
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Product Size</th>
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >SKU</th>
                                                {NO_DISCOUNT ? <></> : (
                                                    <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Buying Price</th>
                                                )}
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Unit Price</th>
                                                {NO_DISCOUNT ? <></> : (
                                                    <>
                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Discount</th>
                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Net Price</th>
                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Pack Of/Set</th>
                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Set Price</th>

                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >MRP</th>
                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Margin</th>
                                                    </>
                                                )}
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Inventory</th>
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Color</th>
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >Default Image</th>
                                                {/* <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" style={{ width: '150px' }}  >Colors</th> */}
                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">Action</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {productVariantList?.map((item, index) => (
                                                <ProductVariantRow
                                                    key={"tr_" + index}
                                                    index={index}
                                                    productVariant={item}
                                                    onCopyProductVariant={() => editProductVariant(item, index)}
                                                    onDeleteProductVariant={() => onClickDelete(item)}
                                                    onPreviewBarcode={() => handleShowBarcodePreview(item)}
                                                    onCopyVariant={() => handleCopyVariant(item)}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            {/* User Modal  */}
            <Modal show={showModal} onHide={hideVariantPopup} id="defaultModal" modal-center="true"
                className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                dialogClassName="w-screen md:w-[60rem] bg-white shadow rounded-md dark:bg-zink-600">
                {productVariant ? <AddProductVariant onSave={onProductVariantSave}
                    data={productVariant}
                    onHide={hideVariantPopup}
                    ProductSizes={ProductSizes}
                    brandDiscount={brandDiscount}
                    productImageList={ProductImages}
                    productColorList={ProductColors}
                    productVariantList={productVariantList ?? []}
                    productSKU={ProductSKU}
                    combinedColorItems={CombinedColorItems}
                /> : <></>}
            </Modal>

            {/* Barcode Preview Modal */}
            <Modal show={showBarcodePreview} onHide={() => setShowBarcodePreview(false)} id="barcodePreviewModal" modal-center="true"
                className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
                <div className="flex items-center justify-between p-4 border-b border-dashed dark:border-zink-500">
                    <h5 className="text-16">Barcode Preview</h5>
                    <button type="button" className="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500" onClick={() => setShowBarcodePreview(false)}>
                        <i className="ri-close-line text-xl"></i>
                    </button>
                </div>
                <div className="p-4">
                    {selectedVariant && (
                        <BarcodeDisplay
                            sku={selectedVariant.sku}
                            sizeInfo={`${selectedVariant.colorCode ? selectedVariant.colorCode : ''} ${selectedVariant.productsizesProductvariants?.name || ''}`}
                            quantity={selectedVariant.packOf || 0}
                            extraInfo={selectedVariant.externalSku || ''}
                        />
                    )}
                </div>
                <div className="flex items-center justify-end p-4 border-t border-dashed dark:border-zink-500">
                    <button type="button" onClick={() => setShowBarcodePreview(false)} className="py-1.5 px-3 text-white transition-all duration-200 ease-linear rounded-md bg-red-500 border-red-500 hover:bg-red-600 hover:border-red-600">Close</button>
                </div>
            </Modal>
        </div>
    )
};

export const ProductVariant = React.memo(ProductVariantComponent);



interface ProductVariantRowProps {
    productVariant: any;
    index: number;
    onCopyProductVariant: (item: any, index: number) => void;
    onDeleteProductVariant: (item: any) => void;
    onPreviewBarcode: (item: any) => void;
    onCopyVariant: (item: any) => void;
}

const ProductVariantRow: React.FC<ProductVariantRowProps> = React.memo(({ productVariant, index, onCopyProductVariant, onDeleteProductVariant, onPreviewBarcode, onCopyVariant }) => {

    const getNetPrice = (productPrice: any) => {
        const unitPrice = productPrice.unitPrice || 0;
        const discount = productPrice.discountValue || 0;
        const netPrice = unitPrice - discount;

        return netPrice;
    }

    const getSetPrice = (productPrice: any) => {
        const packOf = productPrice.packOf || 0;
        //const netPrice = Math.round((getNetPrice(productPrice)*packOf) * 100) / 100  ;

        const netPrice = parseFloat(`${(getNetPrice(productPrice) * packOf).toFixed(2)}`).toFixed(2)
        return netPrice;
    }

    const getDefaultImage = (productPrice: any) => {
        const imgUrl = productPrice?.productvariantsVariantimages?.length > 0 ? productPrice?.productvariantsVariantimages[0]?.url : productPrice?.imageUrl ?? '';
        //console.log('imgUrl', productPrice);
        return imgUrl ? getImageUrl(imgUrl, 'productThumbnail') : '';
    }

    return (    

        <tr key={"tr_PV_" + index} className="odd:bg-white even:bg-slate-50 dark:odd:bg-zink-700 dark:even:bg-zink-600" style={productVariant.isEdit ? { border: 'custom 2px solid' } : {}}>
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.productsizesProductvariants?.name}</td>
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.sku}</td>

            {NO_DISCOUNT ? <></> : (
                <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.buyingPrice}</td>
            )}
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.unitPrice}</td>

            {NO_DISCOUNT ? <></> : (
                <>
                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.discountValue}{' (' + productVariant?.discountPercent + '%)'}</td>
                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{getNetPrice(productVariant)}</td>

                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.packOf}</td>
                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{getSetPrice(productVariant)}</td>
                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.mrp}</td>
                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.margin}</td>
                </>
            )}
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{productVariant?.inventory}</td>
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">

                {productVariant?.colorCode?.length > 0 ? (
                    <div
                        className="flex items-center justify-center size-6 border rounded-md border-slate-200 dark:border-zink-500"
                        style={{
                            background: productVariant?.colorCode ?? '#ffffff',
                            width: 20,
                            cursor: 'pointer',
                            height: 20,
                            borderRadius: 5,
                            textAlign: 'center',
                            marginRight: 5,
                            verticalAlign: 'center',
                        }}
                    >
                    </div>
                ) : <MultiColorBox colors={ProductColors?.filter(item => item.selected == true).map((color) => color.colorCode)} />}

            </td>
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                {getDefaultImage(productVariant) ? (
                    <img src={getDefaultImage(productVariant)} alt="Product Image"
                        className="size-15 border rounded-md border-slate-200 dark:border-zink-500" style={{ width: 50, height: 50, cursor: 'pointer', borderRadius: 5, textAlign: 'center', marginRight: 5, verticalAlign: 'center' }} />
                ) : (
                    <div className="size-15 border rounded-md border-slate-200 dark:border-zink-500 flex items-center justify-center text-slate-400 text-xs" style={{ width: 50, height: 50, borderRadius: 5 }}>
                        No Image
                    </div>
                )}
            </td>
            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                <div className="flex justify-start gap-2" >

                    {(productVariant?.id &&
                        <Link data-modal-target="addUserModal" to="#!"
                            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                            onClick={() => {
                                onCopyProductVariant(productVariant, index)
                            }}>
                            <Pencil className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                        </Link>
                    )}
                    <Link to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                        onClick={() => {
                            onPreviewBarcode(productVariant)
                        }}>
                        <ScanBarcode className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                    </Link>
                    <Link to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-blue-500 bg-blue-100 hover:text-white hover:bg-blue-500 dark:bg-blue-500/20 dark:hover:bg-blue-500"
                        title="Copy Variant"
                        onClick={() => {
                            onCopyVariant(productVariant)
                        }}>
                        <Copy className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                    </Link>
                    <Link to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-red-500 bg-red-100 hover:text-white hover:bg-red-500 dark:bg-red-500/20 dark:hover:bg-red-500"
                        onClick={() => {
                            onDeleteProductVariant(productVariant)
                        }}>
                        <Trash2 className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                    </Link>
                </div>
            </td>
        </tr>
    )
});





